{
  "addressForm": {
    "title": "Titel",
    "firstName": {
      "label": "Vorname",
      "placeholder": "Vorname"
    },
    "lastName": {
      "label": "Nachname",
      "placeholder": "Nachname"
    },
    "address1": "Straße und Hausnr.",
    "address2": "Zusatz Adresse (optional)",
    "country": "Land",
    "city": {
      "label": "Ort",
      "placeholder": "Ort"
    },
    "state": "State",
    "zipCode": {
      "label": "Postleitzahl",
      "placeholder": "Postleitzahl"
    },
    "phoneNumber": {
      "label": "Telefonnr. (optional)",
      "placeholder": "Telefonnr."
    },
    "saveAsDefault": "Save as default",
    "chooseAddress": "Choose address",
    "streetAddress": "Straße und Hausnr.",
    "aptSuite": "Zusatz Adresse",
    "selectOne": "Land",
    "setAsDefault": "Als Standard einstellen",
    "titleRequired": "Title is required.",
    "userAddressAddSuccess": "Neue Adresse wurde erfolgreich hinzugefügt",
    "userAddressUpdateSuccess": "Adresse wurde erfolgreich aktualisiert",
    "userAddressDeleteSuccess": "Adresse wurde erfolgreich gelöscht",
    "invalidAddress": "Invalid Address"
  },
  "addressBook": {
    "addNewShippingAddress": "Neue Adresse hinzufügen",
    "editShippingAddress": "Bearbeiten der adresse",
    "areYouSureToDeleteAddress": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
    "addNewAddress": "Neue Adresse eingeben",
    "addAddress": "Adresse eingeben",
    "updateAddress": "Speichern",
    "backToAddressList": "Zurück zur Übersicht"
  },
  "addressCard": {
    "default": "DEFAULT",
    "selected": "Selected",
    "setAsDefault": "Als Standard einstellen",
    "shipTo": "Ship To",
    "billTo": "Bill To"
  }
}